/* eslint-disable react/react-in-jsx-scope */
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { defaultThemes } from "@/libs/themesList";
import { MoonIcon, SunIcon } from "lucide-react";
import { Dispatch, SetStateAction } from "react";
type ThemeColors = Record<string, string>;

type ThemeValues = {
  name: string;
  value: string;
  colors: ThemeColors;
};
export const ToggleTheme = ({
  saveCustomThemeToDatabase,
  setCustomColors,
  setIsEditing,
  customColors,
}: {
  saveCustomThemeToDatabase: (colors: ThemeValues) => void;
  setCustomColors: Dispatch<SetStateAction<ThemeValues>>;
  setIsEditing: (editing: boolean) => void;
  customColors: ThemeValues;
}) => {
  return (
    <div className="flex items-center gap-2">
      <Label htmlFor="theme-switch">
        <SunIcon className="size-4" />
      </Label>
      <Switch
        checked={customColors.value === "dark"}
        onCheckedChange={(checked) => {
          const tm = checked ? "dark" : "light";
          const currentThemeData = defaultThemes.find((t) => t.value === tm);
          setCustomColors(currentThemeData as ThemeValues);
          saveCustomThemeToDatabase(currentThemeData as ThemeValues);
          setIsEditing(true);
        }}
        id="theme-switch"
      />
      <Label htmlFor="theme-switch">
        <MoonIcon className="size-4" />
      </Label>
    </div>
  );
};
